import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiRegister, apiMe, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    apiMe().then(setUser).catch(() => { setToken(null); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { token, user } = await apiLogin(email, password);
    setToken(token);
    setUser(user);
    return user;
  };

  const register = async (payload) => {
    const { token, user } = await apiRegister(payload);
    setToken(token);
    setUser(user);
    return user;
  };

  const logout = () => { setToken(null); setUser(null); };

  const ssoComplete = (token, u) => { setToken(token); setUser(u); };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, ssoComplete }}>
      {children}
    </AuthContext.Provider>
  );
}
